import React, { Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import NotificationsIcon from '@material-ui/icons/Notifications';
import PersonIcon from '@material-ui/icons/Person';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

import { useDispatch } from 'react-redux';
import {logout} from "../../store/auth/actions";

function Navbar() {
  const history = useHistory();
  const dispatch = useDispatch();

  return (
    <Fragment>
      <IconButton color="inherit">
        <Badge badgeContent={0} color="secondary">
          <NotificationsIcon/>
        </Badge>
      </IconButton>
      <IconButton color="inherit">
        <Badge badgeContent={0} color="secondary">
          <PersonIcon/>
        </Badge>
      </IconButton>
      <IconButton
        color="inherit"
        onClick={() => {
          dispatch(logout());
          history.push('/login');
        }}
      >
        <Badge badgeContent={0} color="secondary">
          <ExitToAppIcon/>
        </Badge>
      </IconButton>
    </Fragment>
  );
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/template/Navbar/index.jsx